const clipboard = require('clipboard-polyfill');

const copyToClipboard = (text) => {
  if (text) clipboard.writeText(text);
};

export default copyToClipboard;
